module.exports = __webpack_public_path__ + "img/teacherTrain-3.cac08f41.jpg";